import React from 'react'
import Layout from '../../components/corporateAdmin/Layout'
import StaterCard from '../web/StaterCard'

function Dashboard() {
  return (
    <div>
      <Layout>
        <h1 className='text-2xl font-bold px-2'>Corporate Admin Dashboard</h1>
        <StaterCard/>

      </Layout>
    </div>
  )
}

export default Dashboard
